(function ($, epiForms) {

	if (typeof epiForms === 'undefined') {
		return;
	}

	epiForms(document).ready(function () {
		epiForms('.EPiServerForms').on('formsSubmitted', function () {
			var $form = $(this);

			$('html, body').animate({
				scrollTop: $form.offset().top - 40
			});
		});
	});

})(jQuery, window.$$epiforms);
